(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-card-carat-selector"] && !Shopify.designMode) return;
  try {
    class CaratProductSwitcher extends HTMLElement {
    connectedCallback() {
      this.productCard = this.closest('product-card');
      this.swatches = this.querySelectorAll('.carat-product-switcher__swatch');

      this.swatches.forEach(swatch => {
        swatch.addEventListener('click', this.handleSwatchClick.bind(this));
      });
    }

    handleSwatchClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const swatch = event.currentTarget;

      // Update active state
      this.swatches.forEach(s => {
        s.classList.remove('carat-product-switcher__swatch--active');
        s.setAttribute('aria-pressed', 'false');
      });
      swatch.classList.add('carat-product-switcher__swatch--active');
      swatch.setAttribute('aria-pressed', 'true');

      // Get product data from the clicked swatch
      const productData = {
        url: swatch.dataset.productUrl,
        title: swatch.dataset.productTitle,
        price: swatch.dataset.productPrice,
        comparePrice: swatch.dataset.productComparePrice,
        image: swatch.dataset.productImage,
        id: swatch.dataset.productId
      };

      this.updateProductCard(productData);
    }

    updateProductCard(productData) {
      if (!this.productCard) return;

      // Update product card link
      const productLink = this.productCard.querySelector('.product-card__link');
      if (productLink) {
        productLink.href = productData.url;
      }

      // Update title link
      const titleLink = this.productCard.querySelector('.product__title');
      if (titleLink) {
        titleLink.href = productData.url;
        const titleText = titleLink.querySelector('p');
        if (titleText) {
          titleText.textContent = productData.title;
        }
      }

      // Update price - there may be multiple price containers (regular view + zoom-out view)
      const priceContainers = this.productCard.querySelectorAll('[ref="priceContainer"]');
      priceContainers.forEach(priceContainer => {
        if (productData.comparePrice) {
          priceContainer.innerHTML = `
            <span role="group">
              <span class="visually-hidden">Sale price</span>
              <span class="price">${productData.price}</span>
            </span>
            <span role="group">
              <span class="visually-hidden">Regular price</span>
              <span class="compare-at-price">${productData.comparePrice}</span>
            </span>
          `;
        } else {
          priceContainer.innerHTML = `<span class="price">${productData.price}</span>`;
        }
      });

      // Update featured image
      const slideshow = this.productCard.querySelector('slideshow-component');
      if (slideshow && productData.image) {
        const firstSlide = slideshow.querySelector('slideshow-slide');
        if (firstSlide) {
          const img = firstSlide.querySelector('img');
          if (img) {
            // Update srcset and src for the new image
            const baseUrl = productData.image.split('?')[0];
            img.src = productData.image;
            img.srcset = `
              ${baseUrl}?width=165 165w,
              ${baseUrl}?width=360 360w,
              ${baseUrl}?width=533 533w,
              ${baseUrl}?width=720 720w,
              ${baseUrl}?width=940 940w,
              ${baseUrl}?width=1066 1066w
            `;
            img.alt = productData.title;
          }
        }
      }

      // Update product card link wrapper if it exists
      const productCardLink = this.productCard.closest('product-card-link');
      if (productCardLink) {
        productCardLink.setAttribute('data-product-id', productData.id);
        productCardLink.setAttribute('data-featured-media-url', productData.image);
      }
    }
  }

  if (!customElements.get('carat-product-switcher')) {
    customElements.define('carat-product-switcher', CaratProductSwitcher);
  }
  } catch(e) { console.error(e); }
})();

})();
